import React from 'react';
import Page from '../../components/Page';
import Footer from '../../components/Footer';
import { flexContainer, wrapper, title, image, rightMargin, listBox } from './LastPageStyle';
import imgIT from '../../assets/media/data1.png';

const DataScienceLastPage = () => {
    return (
        <Page fixedPageHeight>
            <div className={flexContainer}>
                <div className={title}>Zielgerichtete Realisierung von Big Data &amp; Data Analytics-Anwendungen</div>
                <h2>Daten zu profitablem Nutzen transformieren</h2>
                <p>
                    Zellweger Management Consultants (ZMC) kombinieren die langjährige Erfahrung in den Bereichen
                    «Digitale Geschäftstransformation», «Supply Chain- und Operations Management» sowie «Service» mit
                    Big Data und Data Science-Ansätzen.
                </p>
                <div className={wrapper}>
                    <img className={`${image} ${rightMargin}`} src={imgIT} alt="IT" />
                    <div className={listBox}>
                        <ul>
                            <li>Big Data Inventory &amp; Maturity Assessment</li>
                            <li>Data Health Check, Data Assessment Robot (DAR)</li>
                            <li>Data Science Sprint (2 – 4 Wochen)</li>
                            <li>Big Data-Strategie &amp; Roadmap</li>
                            <li>Datenmanagement-Konzept</li>
                            <li>Datenbereinigung und -aufbereitung für Big Data-Anwendungen</li>
                            <li>
                                Feasibility und Prototyping von Big Data-Anwendungen und selbstlernenden Algorithmen in
                                den Bereichen:
                                <ul>
                                    <li>Geschäftsmodelle, Produkte und Dienstleistungen/Service</li>
                                    <li>
                                        Supply Chain und Operations:
                                        <ul>
                                            <li>Planung</li>
                                            <li>Einkauf</li>
                                            <li>Produktion</li>
                                            <li>Logistik</li>
                                        </ul>
                                    </li>
                                    <li>Vertrieb &amp; Service</li>
                                </ul>
                            </li>
                            <li>
                                Entwicklung von Lösungen für die Segmentierung und Strukturierung von internen/externen
                                Daten
                            </li>
                            <li>
                                Analyse und Optimierung von Geschäftsprozessen auf der Basis von Big Data (Process
                                Mining)
                            </li>
                            <li>Dynamische Simulation</li>
                            <li>Big Data Experience Lab, Big Data- und Data Analytics-Training</li>
                            <li>Embedded Data Scientist</li>
                        </ul>
                    </div>
                </div>
                <p style={{ marginTop: 0, marginBottom: '4mm' }}>
                    Durch die Verankerung von datenbasierten Geschäftsmodellen, Produkten und Dienstleistungen leisten
                    wir einen nachhaltigen Beitrag für die positive Geschäftsentwicklung (Umsatz, Marge). Gleichzeitig
                    verbessern wir durch gezielte Nutzung von Daten die Effektivität und Effizienz der End-to-End Supply
                    Chain sowie der Geschäftsprozesse.
                </p>
                <h2>Namhafte Kunden vertrauen uns</h2>
                <p>
                    Nationale und internationale Industrie- und Handelsunternehmen wählen uns als Partner für die
                    digitale Geschäftstransformation und insbesondere für die Realisierung von Big Data- und Data
                    Analytics-Anwendungen.
                </p>
                <div style={{ flex: 1 }} />
                <Footer />
            </div>
        </Page>
    );
};

export default DataScienceLastPage;
